<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            v-if="schools.length"
            :fields="fields"
            :items="schools"
            :filter-included-fields="filterIncludedFields">
            <template v-slot:options>
                <div class="text-right">
                    <b-button
                        class="btn-copy"
                        v-b-modal="'copy-school-modal'"
                        variant="primary">
                        {{ $t('school.copy_school') }}
                    </b-button>
                </div>

                <div class="text-right">
                    <b-button
                        class="btn-add"
                        v-b-modal="'school-modal'"
                        variant="primary">
                        {{ $t('school.new_school') }}
                    </b-button>
                </div>
            </template>

            <template v-slot:cell(school_type)="data">
                <span>{{ schoolTypesIn[data.item.school_type] }}</span>
            </template>

            <template v-slot:cell(actions)="data">
                <div class="actions">
                    <b-button
                        class="btn-open btn-open-schools"
                        :v-b-tooltip="$t('common.open')"
                        variant="primary-icon-only"
                        @click="onSelect(data.item.id)"></b-button>

                    <b-button
                        class="btn-edit btn-edit-schools"
                        v-b-modal="'school-modal' + data.item.id"
                        :v-b-tooltip="$t('school.change')"
                        variant="primary-icon-only"></b-button>

                    <design-2021-school-index-update-school-modal-component
                        :school="data.item"
                        :school-types-in="schoolTypesIn">
                    </design-2021-school-index-update-school-modal-component>

                    <b-button
                        class="btn-remove btn-remove-schools"
                        :v-b-tooltip="$t('school.change')"
                        variant="danger-icon-only"
                        @click="onRemove(data.item.id)"></b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>

        <design-2021-school-index-add-school-modal-component :school-types-in="schoolTypesIn">
        </design-2021-school-index-add-school-modal-component>

        <design-2021-school-index-copy-school-modal-component
            :school-types-in="schoolTypesIn"
            :schools-in="schools">
        </design-2021-school-index-copy-school-modal-component>
    </div>
</template>

<script>
import { ords } from '../../app';
import Design2021SchoolIndexAddSchoolModalComponent from './modals/design-2021-school-index-add-school-modal-component.vue';
import Design2021SchoolIndexUpdateSchoolModalComponent from './modals/design-2021-school-index-update-school-modal-component.vue';
import Design2021SchoolIndexCopySchoolModalComponent from './modals/design-2021-school-index-copy-school-modal-component.vue';
import Design2021ApprenticeDataTable from '../common/design-2021-apprentice-data-table.vue';

export default {
    name: 'design-2021-school-index-component',

    components: {
        Design2021ApprenticeDataTable,
        Design2021SchoolIndexCopySchoolModalComponent,
        Design2021SchoolIndexUpdateSchoolModalComponent,
        Design2021SchoolIndexAddSchoolModalComponent,
    },

    props: {
        schoolTypesIn: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loaded: false,

            schools: [],

            filterIncludedFields: ['id', 'name', 'city'],

            fields: [
                {
                    key: 'id',
                    label: 'ID',
                    sortable: true,
                },
                {
                    key: 'name',
                    label: this.$t('common.name'),
                    sortable: true,
                },
                {
                    key: 'city',
                    label: this.$t('common.city'),
                    sortable: true,
                },
                {
                    key: 'school_type',
                    label: 'Type',
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },

    methods: {
        onRemove(id) {
            this.alert
                .confirm(this.$t('school.delete_school'), this.$t('school.are_you_sure_you_want_to_delete_this_school'))
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();
                        this.axios
                            .delete('/school/delete/' + id)
                            .then(() => {
                                ords.use('school').remove(id);

                                this.alert.success();
                            })
                            .catch(() => {
                                this.alert.ajaxError(error);
                            });
                    }
                });
        },

        onSelect(id) {
            window.location.href = baseUrl + '/school/select/' + id;
        },
    },

    mounted() {
        if (!this.loaded) {
            this.axios
                .get(this.routes.schoolsGet())
                .then((response) => {
                    ords.use('school').add(response.data);

                    ords.use('school')
                        .get()
                        .subscribe((school) => {
                            this.schools = school;
                        });
                })
                .catch(() => {
                    this.alert.ajaxError(error);
                });

            this.loaded = true;
        }
    },
};
</script>

<style scoped lang="scss">
.actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    .btn {
        font-size: 1.125rem;

        &:before,
        &:after {
            margin-right: 0;
        }

        &:not(:last-child) {
            margin-right: map-get($grid-gutter-spacing, 'eight');
        }
    }

    .btn-edit-schools:first-child {
        margin-right: 11px;
    }
}

.btn-copy {
    margin-right: 4px;
}
</style>
